module.exports = __webpack_public_path__ + "img/5_40.bf6c855c.png";